import { AMPM_OPTIONS, DataTypes, HOURS, InputTypes, MINUTES, TIMEZONES, US_STATES } from "../types/schema";

// src/utils/schemaConverter.js
// src/components/v2/utils/schemaConverter.js
// src/utils/schemaConverter.js (update the convertToJSONSchema function)
export const convertToJSONSchema = (wizardConfig) => {
    const properties = {};
    const required = [];
    const uiSchema = {};
    const sections = [];

    wizardConfig.sections.forEach(section => {
        const sectionFields = [];

        section.fields.forEach(field => {
            // Build JSON Schema property
            let property = {
                type: field.validation.dataType === 'numeric' ? 'number' : 'string',
                title: field.label,
                description: field.description || undefined
            };

            if (field.validation.required) {
                required.push(field.name);
            }

            // Handle specific input types
            switch (field.type) {
                case InputTypes.EMAIL:
                    property.format = 'email';
                    property.pattern = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$';
                    break;

                case InputTypes.PHONE:
                    property.format = 'phone';
                    property.pattern = '^\\(?([0-9]{3})\\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$';
                    break;

                case InputTypes.STATE:
                    property.enum = field.options || US_STATES;
                    property.enumNames = field.options || US_STATES;
                    break;

                case InputTypes.TIME:
                    property.type = 'object';
                    property.properties = {
                        hour: { type: 'string', enum: field.timeConfig?.hourOptions || HOURS },
                        minute: { type: 'string', enum: field.timeConfig?.minuteOptions || MINUTES },
                        ampm: { type: 'string', enum: field.timeConfig?.ampmOptions || AMPM_OPTIONS }
                    };
                    if (field.timeConfig?.includeTimezone) {
                        property.properties.timezone = {
                            type: 'string',
                            enum: field.timeConfig?.availableTimezones || TIMEZONES
                        };
                    }
                    property.required = ['hour', 'minute', 'ampm'];
                    break;

                case InputTypes.DROPDOWN:
                    property.enum = field.options || [];
                    property.enumNames = field.options || [];
                    break;

                case InputTypes.RADIO:
                    property.enum = field.options || [];
                    uiSchema[field.name] = {
                        'ui:widget': 'radio'
                    };
                    break;

                case InputTypes.TEXTAREA:
                    uiSchema[field.name] = {
                        'ui:widget': 'textarea',
                        'ui:options': {
                            rows: 4
                        }
                    };
                    break;

                case InputTypes.DATEPICKER:
                    property.format = 'date';
                    uiSchema[field.name] = {
                        'ui:widget': 'date'
                    };
                    break;
            }

            // Add validation rules for text-based fields
            if (field.type === 'textbox' || field.type === 'textarea') {
                if (field.validation.minLength !== null && property.type === 'string') {
                    property.minLength = field.validation.minLength;
                }
                if (field.validation.maxLength !== null && property.type === 'string') {
                    property.maxLength = field.validation.maxLength;
                }

                if (field.type === 'textbox' && field.validation.dataType === 'numeric') {
                    if (field.validation.minValue !== null) {
                        property.minimum = field.validation.minValue;
                    }
                    if (field.validation.maxValue !== null) {
                        property.maximum = field.validation.maxValue;
                    }
                }
            }

            // Add custom properties for runtime
            property.customConfig = {
                type: field.type,
                required: field.validation.required || false,
                validation: field.validation,
                timeConfig: field.timeConfig,
                placeholder: field.placeholder
            };

            if (field.conditions && field.conditions.length > 0) {
                property.customConfig.conditions = field.conditions;
            }


            // Add alert notes
            if (field.alertNotes && field.alertNotes.length > 0) {
                property.alertNotes = field.alertNotes;
            }

            properties[field.name] = property;
            sectionFields.push(field);
        });

        sections.push({
            ...section,
            fields: sectionFields,
            skipRules: section.skipRules || []
        });
    });

    return {
        schema: {
            type: 'object',
            properties,
            required: required.length > 0 ? required : undefined
        },
        uiSchema,
        sections,
        name: wizardConfig.name,
        description: wizardConfig.description
    };
};